import React, { Component } from 'react'

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    this.colors = {
      1: null,
      2: '#428000',
      3: '#e69900',
      4: '#e60000',
      5: '#e60000',
    }
  }

  render = () => {
    return (
      <table className="table table-hover">
        <thead>
          <tr>
            <th scope="">Timestamp</th>
            <th scope="">Message</th>
            <th scope="">Status</th>
            <th scope="">Reason</th>
          </tr>
        </thead>
        <tbody>
          {
            this.props.data.map(({timestamp, message, status, reason}, index) => {
              return (
                <tr key={index}>
                  <td className="userRow">{timestamp}</td> 
                  <td className="userRow">{message}</td> 
                  <td className="userRow" style={{fontWeight: 'bold', color: this.colors[Math.floor(status/100)]}}>{status}</td> 
                  <td className="userRow">{reason}</td> 
                </tr>
              )
            })
          }
        </tbody>
      </table>
    )
  }
}

export default Table;


// WEBPACK FOOTER //
// ./src/Components/Logs/Table.js